import { ApprovedPaymentSummary } from "../../../domain/proposals/paymentSummary"
import { WorkareaGroup } from "../../../domain/workareas/group"
import VSpace from "../../common/VSpace"
import IntervalBased from "./IntervalBased"
import PerVisit from "./PerVisit"
import ProgressBased from "./ProgressBased"

type Props = {
  summary: ApprovedPaymentSummary
  workareaGroups: WorkareaGroup[]
}

const Summary = ({summary, workareaGroups}: Props) => {
  return <VSpace size="large">
    {summary.progressBased && <ProgressBased summary={summary.progressBased} workareaGroups={workareaGroups} />}
    {summary.intervalBased && <IntervalBased summary={summary.intervalBased} workareaGroups={workareaGroups} />}
    {summary.perVisit && <PerVisit summary={summary.perVisit} workareaGroups={workareaGroups} />}
  </VSpace>
}

export default Summary
